import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "align-middle py-3" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "media-body ps-3" }
const _hoisted_4 = { class: "text-muted small" }
const _hoisted_5 = { class: "align-middle py-3 d-none d-md-block" }
const _hoisted_6 = { class: "small" }
const _hoisted_7 = { class: "align-middle py-3" }
const _hoisted_8 = { class: "small" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_image = _resolveComponent("user-image")!

  return (_openBlock(), _createElementBlock("tr", {
    class: "cursor-pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router.push({name:'recruitment.pending',params:{user_id:_ctx.recruit.id}})))
  }, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_user_image, {
          source: _ctx.recruit.image
        }, null, 8, ["source"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, _toDisplayString(_ctx.recruit.name), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.recruit.email), 1)
        ])
      ])
    ]),
    _createElementVNode("td", _hoisted_5, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-muted small" }, "Applied For", -1)),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.recruit.applied), 1)
    ]),
    _createElementVNode("td", _hoisted_7, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-muted small" }, "Submitted", -1)),
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.recruit.created_at), 1)
    ]),
    _cache[3] || (_cache[3] = _createElementVNode("td", { class: "align-middle py-3" }, [
      _createElementVNode("div", { class: "d-flex justify-content-end" }, [
        _createElementVNode("i", { class: "fa fa-chevron-right fa-2x text-light" })
      ])
    ], -1))
  ]))
}